import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import DeliverySidebar from "../Layouts/DeliverySidebar";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class ApgarScore extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      bp: "",
      temp: "",
      pulse: "",
      hemorrhage: "",
      uterinecontraction: "",
      tablevaluesglobal: "",
      visitid: localStorage.getItem("currentVisitId"),
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".obstudydone").on("click", function () {
      $(".obSoundDone").show();
    });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    var visitid = $(".visitid").text();
    // console.log(localStorage.getItem('accessToken'))
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: visitid,
    };

    event.preventDefault();

    console.log(this.state.tablevaluesglobal);

    var dict = {
      Stimulationm0: this.state.tablevaluesglobal[1]["M0"],
      Stimulationm10: this.state.tablevaluesglobal[1]["M10"],
      Stimulationm5: this.state.tablevaluesglobal[1]["M5"],
      Respirationm0: this.state.tablevaluesglobal[2]["M0"],
      Respirationm5: this.state.tablevaluesglobal[2]["M5"],
      Respirationm10: this.state.tablevaluesglobal[2]["M10"],
      Colorationm0: this.state.tablevaluesglobal[3]["M0"],
      Colorationm5: this.state.tablevaluesglobal[3]["M5"],
      Colorationm10: this.state.tablevaluesglobal[3]["M10"],
      Reactionm0: this.state.tablevaluesglobal[4]["M0"],
      Reactionm5: this.state.tablevaluesglobal[4]["M5"],
      Reactionm10: this.state.tablevaluesglobal[4]["M10"],
      CardiacAtivitym0: this.state.tablevaluesglobal[5]["M0"],
      CardiacAtivitym10: this.state.tablevaluesglobal[5]["M10"],
      CardiacAtivitym5: this.state.tablevaluesglobal[5]["M5"],
      Totalm0: this.state.tablevaluesglobal[4]["M0"],
      Totalm5: this.state.tablevaluesglobal[4]["M5"],
      Totalm10: this.state.tablevaluesglobal[4]["M10"],

      aspirationobsv: this.state.tablevaluesglobal[1]["Observation"],
      aspiration: this.state.tablevaluesglobal[1]["No"],
      ventilationobsv: this.state.tablevaluesglobal[2]["Observation"],
      ventilation: this.state.tablevaluesglobal[2]["No"],
      oxygenation: this.state.tablevaluesglobal[3]["No"],
      oxygenationobsv: this.state.tablevaluesglobal[3]["Observation"],
      intubation: this.state.tablevaluesglobal[4]["No"],
      intubationobsv: this.state.tablevaluesglobal[4]["Observation"],
      cardiacMessage: this.state.tablevaluesglobal[5]["No"],
      cardiacMessageobsv: this.state.tablevaluesglobal[5]["Observation"],
      transferNeonatology: this.state.tablevaluesglobal[6]["No"],
      transferNeonatologyobsv: this.state.tablevaluesglobal[6]["Observation"],
      administrationCare: this.state.tablevaluesglobal[7]["No"],
      administrationCareobsv: this.state.tablevaluesglobal[7]["Observation"],
    };
    // console.log(dict)
    this.setState({
      loading: true
    })
    axios
      .post(this.api_url+"delivery/apgar", dict, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);
        this.setState({
          loading: false
        })
        if (response.data["status"]) {
          $(".alert-success").show();
          // setTimeout(function () {
          //     window.location.href = '/delivery/immediate/observation/mother'
          // }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  handleTableChange(event) {
    console.log(event);
    this.setState({ myParentTrigger: this.state.myParentTrigger + "a" });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    console.log(data);
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};

      trimobj.act1 = data[i][0];
      trimobj.M0 = data[i][1];
      trimobj.M5 = data[i][2];
      trimobj.M10 = data[i][3];
      trimobj.No = data[i][5];
      trimobj.Observation = data[i][6];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    const data = [
      ["Act", "M0", "M5", "M10", "Act", "Yes/No", "Observations/treatment"],
      ["Stimulation", "", "", "", "Aspiration", "", ""],
      ["Respiration", "", "", "", "Ventilation", "", ""],
      ["Coloration", "", "", "", "Oxygenation", "", ""],
      ["Reaction", "", "", "", "Intubation", "", ""],
      ["Cardiac activity", "", "", "", "Cardiac message", "", ""],
      ["Total", "", "", "", "Transfer neonatology", "", ""],
      ["", "", "", "", "Administration care", "", ""],
      [
        "",
        "",
        "",
        "",
        "Antibiotics/vit K/ eyes drops/ control the cord",
        "",
        "",
      ],
    ];
    const columns = [
      "Apgar Score",
      "",
      "",
      "",
      "Reanimation of the Newborn",
      "",
      "",
      "",
    ];
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { bp, temp, pulse, hemorrhage, uterinecontraction, loading } = this.state;

    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    return (
      <div>
        <Headers />
        <DeliverySidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Apgar Score Reanimation
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="#editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default ApgarScore;
